/**
 * If you add a member to this enum you should update `malouErrorCodeToHttpStatus`.
 * You can also add a traduction in `getReadableErrorForMalouErrorCode` for the frontend if needed.
 */
export enum MalouErrorCode {
    // GENERAL ERRORS
    BODY_VALIDATION_ERROR = 'BODY_VALIDATION_ERROR',
    QUERY_VALIDATION_ERROR = 'QUERY_VALIDATION_ERROR',
    PARAMS_VALIDATION_ERROR = 'PARAMS_VALIDATION_ERROR',
    INVALID_URL = 'INVALID_URL',

    // AGENDA
    AGENDA_DATABASE_CONNECTION_FAILED = 'AGENDA_DATABASE_CONNECTION_FAILED',

    // AI
    NOT_ENOUGH_CREDIT_TO_MAKE_AI_API_CALL = 'NOT_ENOUGH_CREDIT_TO_MAKE_AI_API_CALL',
    TEXT_TYPE_NOT_SUPPORTED = 'TEXT_TYPE_NOT_SUPPORTED',
    AI_REQUEST_FAILED = 'AI_REQUEST_FAILED',
    AI_INVALID_RESPONSE_FORMAT = 'AI_INVALID_RESPONSE_FORMAT',

    // API KEYS
    INVALID_API_KEY = 'INVALID_API_KEY',

    ABOVE_RESTAURANTS_LIMITS = 'ABOVE_RESTAURANTS_LIMITS',

    // ATTRIBUTES
    ATTRIBUTES_GMB_NOT_CONNECTED = 'ATTRIBUTES_GMB_NOT_CONNECTED',

    // AUTOMATIONS
    INCONSISTENT_RESTAURANT_ID = 'INCONSISTENT_RESTAURANT_ID',

    // CALENDAR EVENTS
    CALENDAR_SYNC_ALREADY_RUNNING = 'CALENDAR_SYNC_ALREADY_RUNNING',

    // CAMPAIGN
    CAMPAIGN_MISSING_QUERY_PARAM = 'CAMPAIGN_MISSING_QUERY_PARAM',
    CAMPAIGN_NOT_FOUND = 'CAMPAIGN_NOT_FOUND',
    CAMPAIGN_DUPLICATE_RECORD_ERROR = 'CAMPAIGN_DUPLICATE_RECORD_ERROR',

    // CASL
    CASL_UNKNOWN_ROLE = 'CASL_UNKNOWN_ROLE',
    CASL_USER_NOT_DEFINED = 'CASL_USER_NOT_DEFINED',

    // CLIENTS
    CLIENT_CANNOT_PARSE_FILE = 'CLIENT_CANNOT_PARSE_FILE',
    CLIENT_LANGUAGE_NOT_FOUND__REQUIRED_HEADERS = 'CLIENT_LANGUAGE_NOT_FOUND__REQUIRED_HEADERS',
    CLIENT_CANNOT_PARSE_DATA = 'CLIENT_CANNOT_PARSE_DATA',
    COMO_CLIENT_NOT_FOUND = 'COMO_CLIENT_NOT_FOUND',
    COMO_CLIENT_CREATION_FAILED = 'COMO_CLIENT_CREATION_FAILED',
    COMO_CLIENT_UPDATE_FAILED = 'COMO_CLIENT_UPDATE_FAILED',
    ZELTY_ORDER_NOT_FOUND = 'ZELTY_ORDER_NOT_FOUND',
    PROVIDER_CLIENT_NOT_FOUND = 'PROVIDER_CLIENT_NOT_FOUND',

    // COMMENTS
    COMMENT_INVALID_TYPE = 'COMMENT_INVALID_TYPE',
    COMMENT_NOT_FOUND = 'COMMENT_NOT_FOUND',

    // CREDENTIALS
    CREDENTIALS_USECASE_NOT_FOUND = 'CREDENTIAL_USECASE_NOT_FOUND',
    CREDENTIALS_PLATFORM_LOGIN_ERROR = 'CREDENTIALS_PLATFORM_LOGIN_ERROR',
    CREDENTIALS_MISSING_PARAM = 'CREDENTIALS_MISSING_PARAM',
    CREDENTIALS_INSTAGRAM_NOT_FOUND = 'CREDENTIALS_INSTAGRAM_NOT_FOUND',
    INSTAGRAM_ACCOUNT_NOT_FOUND = 'INSTAGRAM_ACCOUNT_NOT_FOUND',
    CREDENTIALS_FACEBOOK_NOT_FOUND = 'CREDENTIALS_FACEBOOK_NOT_FOUND',
    CREDENTIALS_FACEBOOK_ERROR = 'CREDENTIALS_FACEBOOK_ERROR',
    CREDENTIALS_FACEBOOK_PLATFORM_NOT_SUPPORTED = 'CREDENTIALS_FACEBOOK_PLATFORM_NOT_SUPPORTED',
    CREDENTIALS_FACEBOOK_MEDIA_NOT_SUPPORTED = 'CREDENTIALS_FACEBOOK_MEDIA_NOT_SUPPORTED',
    CREDENTIALS_FACEBOOK_CANNOT_FETCH_ACCOUNTS_AND_STORES = 'CREDENTIALS_FACEBOOK_CANNOT_FETCH_ACCOUNTS_AND_STORES',
    CREDENTIALS_TIKTOK_REFRESH_TOKEN_EXPIRED = 'CREDENTIALS_TIKTOK_REFRESH_TOKEN_EXPIRED',
    CREDENTIALS_TIKTOK_NOT_FOUND = 'CREDENTIALS_TIKTOK_NOT_FOUND',
    CREDENTIALS_GMB_REFRESH_TOKEN_EXPIRED = 'CREDENTIALS_GMB_REFRESH_TOKEN_EXPIRED',
    CREDENTIALS_GMB_CREDENTIAL_NOT_FOUND = 'CREDENTIALS_GMB_CREDENTIAL_NOT_FOUND',
    CREDENTIALS_GMB_API_ERROR = 'CREDENTIALS_GMB_API_ERROR',
    CREDENTIALS_GMB_API_DETAILS_ERROR = 'CREDENTIALS_GMB_API_DETAILS_ERROR',
    CREDENTIALS_GMB_POST_SCHEDULE_END_DATE_IN_PAST = 'CREDENTIALS_GMB_POST_SCHEDULE_END_DATE_IN_PAST',
    CREDENTIALS_GMB_API_DESCRIPTION_ERROR = 'CREDENTIALS_GMB_API_DESCRIPTION_ERROR',
    CREDENTIALS_UBEREATS_COOKIE_ERROR = 'CREDENTIALS_UBEREATS_COOKIE_ERROR',
    CREDENTIALS_UBEREATS_COOKIE_NOT_FOUND = 'CREDENTIALS_UBEREATS_COOKIE_NOT_FOUND',
    CREDENTIALS_UBEREATS_UPDATE_COOKIE_FAILED = 'CREDENTIALS_UBEREATS_UPDATE_COOKIE_FAILED',
    CREDENTIALS_ZENCHEF_AUTH_ERROR = 'CREDENTIALS_ZENCHEF_AUTH_ERROR',
    CREDENTIALS_ZENCHEF_WRONG_CREDENTIALS = 'CREDENTIALS_ZENCHEF_WRONG_CREDENTIALS',
    CREDENTIALS_ZENCHEF_NO_PARAMETERS_ACCESS = 'CREDENTIALS_ZENCHEF_NO_PARAMETERS_ACCESS',
    CREDENTIALS_ZENCHEF_ERROR = 'CREDENTIALS_ZENCHEF_ERROR',
    CREDENTIALS_ZENCHEF_CREDENTIAL_NOT_FOUND = 'CREDENTIALS_ZENCHEF_CREDENTIAL_NOT_FOUND',
    CREDENTIALS_ZENCHEF_API_ERROR = 'CREDENTIALS_ZENCHEF_API_ERROR',
    CREDENTIALS_DELIVEROO_COULD_NOT_FETCH_API_WITH_SEVERAL_AGENTS = 'CREDENTIALS_DELIVEROO_COULD_NOT_FETCH_API_WITH_SEVERAL_AGENTS',
    CREDENTIALS_DELIVEROO_LAMBDA_INVOCATION_FAILED = 'CREDENTIALS_DELIVEROO_LAMBDA_INVOCATION_FAILED',
    DELIVEROO_CREDENTIALS_EXPIRED = 'DELIVEROO_CREDENTIALS_EXPIRED',
    CREDENTIALS_DELIVEROO_NOT_FOUND = 'CREDENTIALS_DELIVEROO_NOT_FOUND',
    CREDENTIALS_OPENTABLE_COOKIE_NOT_VALID = 'CREDENTIALS_OPENTABLE_COOKIE_NOT_VALID',

    // EMAILS
    EMAIL_NOT_SENT = 'EMAIL_NOT_SENT',
    EMAIL_INVALID_CATEGORY = 'EMAIL_INVALID_CATEGORY',
    MAILING_NO_USERS = 'MAILING_NO_USERS',

    // DIAGNOSTICS
    DIAGNOSTIC_NOT_FOUND = 'DIAGNOSTIC_NOT_FOUND',
    DIAGNOSTIC_INSTAGRAM_PAGE_NOT_FOUND = 'DIAGNOSTIC_INSTAGRAM_PAGE_NOT_FOUND',
    ERROR_WHILE_CREATING_DIAGNOSTIC = 'ERROR_WHILE_CREATING_DIAGNOSTIC',
    DIAGNOSTIC_INVALID_CATEGORY = 'DIAGNOSTIC_INVALID_CATEGORY',
    DIAGNOSTIC_CANNOT_FETCH_PLACE_DETAILS = 'DIAGNOSTIC_CANNOT_FETCH_PLACE_DETAILS',
    DIAGNOSTIC_NO_KEYWORDS_FOUND = 'DIAGNOSTIC_NO_KEYWORDS_FOUND',
    DIAGNOSTIC_CANNOT_UPDATE_DIAGNOSTIC = 'DIAGNOSTIC_CANNOT_UPDATE_DIAGNOSTIC',

    // FILTERS
    FILTER_START_DATE_AFTER_END_DATE = 'FILTER_START_DATE_AFTER_END_DATE',
    FILTER_MISSING_PARAMS = 'FILTER_MISSING_PARAMS',
    FILTER_METHOD_NOT_IMPLEMENTED = 'FILTER_METHOD_NOT_IMPLEMENTED',
    FILTER_TIME_RANGE_TOO_SHORT = 'FILTER_TIME_RANGE_TOO_SHORT',
    FILTER_TIME_RANGE_TOO_LONG = 'FILTER_TIME_RANGE_TOO_LONG',
    FILTER_INVALID_INSIGHT_PLATFORM = 'FILTER_INVALID_INSIGHT_PLATFORM',

    // FOLDERS
    FOLDER_WITH_SAME_NAME_ALREADY_EXISTS = 'FOLDER_WITH_SAME_NAME_ALREADY_EXISTS',

    // FACEBOOK
    FACEBOOK_API_EXCEPTION = 'FACEBOOK_API_EXCEPTION',

    // FACEBOOK REEL

    // FEEDBACKS
    FEEDBACK_ALREADY_EXISTS = 'FEEDBACK_ALREADY_EXISTS',

    // GIFT DRAW
    CLIENT_ALREADY_PLAYED = 'CLIENT_ALREADY_PLAYED',
    CLIENT_EMAIL_NOT_FOUND = 'CLIENT_EMAIL_NOT_FOUND',
    CLIENT_NOT_FOUND = 'CLIENT_NOT_FOUND',
    GIFT_DRAW_NOT_FOUND = 'GIFT_DRAW_NOT_FOUND',
    DRAW_GIFT_WENT_WRONG = 'DRAW_GIFT_WENT_WRONG',

    // GMB
    GMB_PLACE_ID_IS_NO_LONGER_VALID = 'GMB_PLACE_ID_IS_NO_LONGER_VALID',
    GMB_MISSING_ADDRESS = 'GMB_MISSING_ADDRESS',
    GMB_PIN_DROP_REQUIRED = 'GMB_PIN_DROP_REQUIRED',
    GMB_STOREFRONT_REQUIRED_FOR_CATEGORY = 'GMB_STOREFRONT_REQUIRED_FOR_CATEGORY',
    GMB_ACCOUNT_NOT_FOUND = 'GMB_ACCOUNT_NOT_FOUND',
    GMB_NOT_CONNECTED = 'GMB_NOT_CONNECTED',
    GMAPS_CANNOT_FETCH_PLACE_ADDRESS_COMPONENTS = 'GMAPS_CANNOT_FETCH_PLACE_ADDRESS_COMPONENTS',

    // HELPERS
    HELPERS_RETRY_PLATFORM_SCRAPPER_ERROR = 'HELPERS_RETRY_PLATFORM_SCRAPPER_ERROR',
    HELPERS_INJECTOR_NOT_IMPLEMENTED = 'HELPERS_INJECTOR_NOT_IMPLEMENTED',
    HELPERS_DOWNLOAD_FILE_MISSING_FOLDER = 'HELPERS_DOWNLOAD_FILE_MISSING_FOLDER',

    // HYPERLINE
    HYPERLINE_INTEGRATION_ERROR = 'HYPERLINE_INTEGRATION_ERROR',

    // INSIGHTS
    INSIGHTS_NOT_FOUND = 'INSIGHTS_NOT_FOUND',
    DOWNLOAD_INSIGHTS_AS_PDF_FAILED = 'DOWNLOAD_INSIGHTS_AS_PDF_FAILED',
    INSIGHTS_MAPPER_UNSUPPORTED_METRIC = 'INSIGHTS_MAPPER_UNSUPPORTED_METRIC',

    // JOBS

    // KEYWORDS
    KEYWORD_NOT_FOUND = 'KEYWORD_NOT_FOUND',
    KEYWORDS_GEOSAMPLE_ERROR = 'KEYWORDS_GEOSAMPLE_ERROR',
    KEYWORDS_PLATFORM_NOT_AUTHORIZED = 'KEYWORDS_PLATFORM_NOT_AUTHORIZED',
    KEYWORDS_VOLUME_API_REQUEST_LIMIT_REACHED = 'KEYWORDS_VOLUME_API_REQUEST_LIMIT_REACHED',
    FETCH_KEYWORDS_VOLUME_MONTHLY_ERROR = 'FETCH_KEYWORDS_VOLUME_MONTHLY_ERROR',
    KEYWORDS_VOLUME_API_REQUEST_FAILED = 'KEYWORDS_VOLUME_API_REQUEST_FAILED',
    KEYWORDS_GENERATION_ALREADY_RUNNING = 'KEYWORDS_GENERATION_ALREADY_RUNNING',
    FETCH_KEYWORDS_SEARCH_IMPRESSIONS_ERROR = 'FETCH_KEYWORDS_SEARCH_IMPRESSIONS_ERROR',

    // MEDIAS
    WRONG_MEDIA_FORMAT = 'WRONG_MEDIA_FORMAT',
    WRONG_MEDIA_TYPE = 'WRONG_MEDIA_TYPE',
    CANNOT_DELETE_MEDIAS_FROM_OTHER_RESTAURANTS = 'CANNOT_DELETE_MEDIAS_FROM_OTHER_RESTAURANTS',
    MEDIA_THUMBNAIL_GENERATION_FAILED = 'MEDIA_THUMBNAIL_GENERATION_FAILED',
    MEDIA_UPLOAD_FAILED = 'MEDIA_UPLOAD_FAILED',

    // MEDIAS v2
    CANNOT_COMPUTE_TRANSFORM_DATA_FROM_OLD_MEDIA = 'CANNOT_COMPUTE_TRANSFORM_DATA_FROM_OLD_MEDIA',
    CANNOT_GET_THUMBNAIL_FOR_EDITION_MEDIA = 'CANNOT_GET_THUMBNAIL_FOR_EDITION_MEDIA',

    // MESSAGES

    // MISC
    NO_FILTER_PROVIDED = 'NO_FILTER_PROVIDED',
    NOT_FOUND = 'NOT_FOUND',
    BAD_REQUEST = 'BAD_REQUEST',
    UNAUTHORIZED = 'UNAUTHORIZED',
    FORBIDDEN = 'FORBIDDEN',
    INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
    ABSTRACT_CLASS_ERROR = 'ABSTRACT_CLASS_ERROR',
    MISSING_PARAM = 'MISSING_PARAM',
    INVALID_DATA = 'INVALID_DATA',

    // MULTIMEDIA_STREAMS_INFORMATION
    MULTIMEDIA_STREAMS_INFORMATION_MISSING_INFORMATION = 'MULTIMEDIA_STREAMS_INFORMATION_MISSING_INFORMATION',

    // NFCS
    NFC_NOT_FOUND = 'NFC_NOT_FOUND',

    // NOT_IMPLEMENTED
    NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',

    // ORGANIZATIONS
    ORGANIZATION_NOT_FOUND = 'ORGANIZATION_NOT_FOUND',
    ORGANIZATION_IS_LINKED_TO_A_RESTAURANT = 'ORGANIZATION_IS_LINKED_TO_A_RESTAURANT',

    // PLATFORMS
    PLATFORM_NOT_FOUND = 'PLATFORM_NOT_FOUND',
    RETRIEVE_OVERVIEW_DATA_ERROR = 'RETRIEVE_OVERVIEW_DATA_ERROR',
    PLATFORM_CREDENTIAL_NOT_FOUND = 'PLATFORM_CREDENTIAL_NOT_FOUND',
    PLATFORM_DATA_UNDEFINED_OR_EMPTY = 'PLATFORM_DATA_UNDEFINED_OR_EMPTY',
    PLATFORM_DATA_CRAWLING_ERROR = 'PLATFORM_DATA_CRAWLING_ERROR',
    PLATFORM_SEARCH_RESULT_NOT_ARRAY = 'PLATFORM_SEARCH_RESULT_NOT_ARRAY',
    PLATFORM_CATEGORY_NOT_FOUND = 'PLATFORM_CATEGORY_NOT_FOUND',
    PLATFORM_FB_NOT_CONNECTED = 'PLATFORM_FB_NOT_CONNECTED',
    PLATFORM_NO_DATA_IN_RESPONSE = 'PLATFORM_NO_DATA_IN_RESPONSE',
    PLATFORM_MAPPER_METHOD_NOT_IMPLEMENTED = 'PLATFORM_MAPPER_METHOD_NOT_IMPLEMENTED',
    PLATFORM_FOURSQUARE_NO_VENUES = 'PLATFORM_FOURSQUARE_NO_VENUES',
    PLATFORM_UBEREATS_REVIEWS_FETCH_ERROR = 'PLATFORM_UBEREATS_REVIEWS_FETCH_ERROR',
    PLATFORM_ZENCHEF_FETCH_RESTAURANTS_UNAUTHORIZED_ERROR = 'PLATFORM_ZENCHEF_FETCH_RESTAURANTS_UNAUTHORIZED_ERROR',
    PLATFORM_SCRAPPER_ERROR = 'PLATFORM_SCRAPPER_ERROR',
    PLATFORM_NOT_CONNECTED = 'PLATFORM_NOT_CONNECTED',
    PLATFORM_MAPPER_FAILED_FIELD_PUBLISH = 'PLATFORM_MAPPER_FAILED_FIELD_PUBLISH',
    PLATFORM_MAPPER_CANNOT_PARSE_DATA = 'PLATFORM_MAPPER_CANNOT_PARSE_DATA',
    PLATFORM_MAPPER_MISSING_PARAM = 'PLATFORM_MAPPER_MISSING_PARAM',
    PLATFORM_SERVICE_ERROR = 'PLATFORM_SERVICE_ERROR',
    PLATFORM_SERVICE_NOT_IMPLEMENTED = 'PLATFORM_SERVICE_NOT_IMPLEMENTED',
    PLATFORM_INVALID_KEY = 'PLATFORM_INVALID_KEY',
    PLATFORM_THE_FORK_REVIEWS_MALFORMED_RESPONSE = 'PLATFORM_THE_FORK_REVIEWS_MALFORMED_RESPONSE',
    REPLY_API_FAILED_USE_FALLBACK = 'REPLY_API_FAILED_USE_FALLBACK',
    PLATFORM_REQUIRED = 'PLATFORM_REQUIRED',
    PLATFORM_MISSING_SOCIAL_ID = 'PLATFORM_MISSING_SOCIAL_ID',
    PLATFORM_MISSING_LOCATION_ID = 'PLATFORM_MISSING_LOCATION_ID',
    PLATFORM_MISSING_PERMISSIONS = 'PLATFORM_MISSING_PERMISSIONS',
    PLATFORM_SCRAP_ERROR = 'PLATFORM_SCRAP_ERROR',
    PLATFORM_DELETE_ERROR = 'PLATFORM_DELETE_ERROR',
    PLATFORM_PUBLISH_ERROR = 'PLATFORM_PUBLISH_ERROR',
    PLATFORM_INVALID_PASSWORD = 'PLATFORM_INVALID_PASSWORD',
    FETCH_YELP_WEBSITE_FAILED = 'FETCH_YELP_WEBSITE_FAILED',
    PLATFORM_DELIVEROO_DRN_ID_NOT_FOUND = 'PLATFORM_DELIVEROO_DRN_ID_NOT_FOUND',
    DOORDASH_REVIEWS_FETCH_ERROR = 'DOORDASH_REVIEWS_FETCH_ERROR',
    DOORDASH_STORE_DETAILS_FETCH_ERROR = 'DOORDASH_STORE_DETAILS_FETCH_ERROR',
    DOORDASH_STORES_FETCH_ERROR = 'DOORDASH_STORES_FETCH_ERROR',
    DOORDASH_HOURS_FETCH_ERROR = 'DOORDASH_HOURS_FETCH_ERROR',
    DOORDASH_BUSINESS_ID_FETCH_ERROR = 'DOORDASH_BUSINESS_ID_FETCH_ERROR',
    DOORDASH_REPLY_ERROR = 'DOORDASH_REPLY_ERROR',
    YELP_BUSINESS_UNAVAILABLE = 'YELP_BUSINESS_UNAVAILABLE',
    WEEKLY_INSERT_UBEREATS_PLATFORM_RATINGS = 'WEEKLY_INSERT_UBEREATS_PLATFORM_RATINGS',
    FAILED_TO_FETCH_PLATFORM_RATING = 'FAILED_TO_FETCH_PLATFORM_RATING',

    // PLATFORM INSIGHTS
    PLATFORM_INSIGHTS_ERROR = 'PLATFORM_INSIGHTS_ERROR',

    // POSTS
    MAPSTR_MAPPING_ERROR = 'MAPSTR_MAPPING_ERROR',
    MEDIA_DELETED_FOR_POST = 'MEDIA_DELETED_FOR_POST',
    POST_NOT_FOUND = 'POST_NOT_FOUND',
    FAILED_VIDEO_RESIZE = 'FAILED_VIDEO_RESIZE',
    POSTS_MUST_BE_FROM_SAME_RESTAURANT = 'POSTS_MUST_BE_FROM_SAME_RESTAURANT',
    POST_CREATION_FOR_PLATFORM_FAILED = 'POST_CREATION_FOR_PLATFORM_FAILED',
    POST_MUST_HAVE_MEDIA = 'POST_MUST_HAVE_MEDIA',
    REEL_WITHOUT_VIDEO = 'REEL_WITHOUT_VIDEO',
    POST_IS_NOT_SOCIAL_POST = 'POST_IS_NOT_SOCIAL_POST',
    POST_IS_PUBLISHING = 'POST_IS_PUBLISHING',

    // POST INSIGHTS
    POST_INSIGHTS_NOT_FOUND = 'POST_INSIGHTS_NOT_FOUND',
    POST_INSIGHTS_UNEXPECTED_ERROR = 'POST_INSIGHTS_UNEXPECTED_ERROR',

    // POST PUBLICATION V2
    MISSING_DATA_ON_MEDIA_FOR_TRANSFORM = 'MISSING_DATA_ON_MEDIA_FOR_TRANSFORM',
    // PROVIDERS
    PROVIDER_MAPSTR_NO_DATA = 'PROVIDER_MAPSTR_NO_DATA',
    PROVIDER_INVALID_PLATFORM_KEY = 'PROVIDER_INVALID_PLATFORM_KEY',

    // SERVICES
    SERVICE_INVALID_CONFIGURATION = 'SERVICE_INVALID_CONFIGURATION',

    // SEGMENT_ANALYSIS_PARENT_TOPIC
    SEGMENT_ANALYSIS_PARENT_TOPIC_NO_CATEGORY_FOUND = 'SEGMENT_ANALYSIS_PARENT_TOPIC_NO_CATEGORY_FOUND',

    // PUBSUB
    NO_SUBSCRIPTION_NAME_OR_ID = 'NO_SUBSCRIPTION_NAME_OR_ID',

    // REPORTS
    INVALID_UNSUBSCRIBE_HASH = 'INVALID_UNSUBSCRIBE_HASH',

    // RESTAURANTS
    RESTAURANT_MISSING_LATLNG = 'RESTAURANT_MISSING_LATLNG',
    RESTAURANT_API_LOCATION_ID_NOT_FOUND = 'RESTAURANT_API_LOCATION_ID_NOT_FOUND',
    RESTAURANT_NOT_FOUND = 'RESTAURANT_NOT_FOUND',
    RESTAURANT_BRICKS_NOT_FOUND = 'RESTAURANT_BRICKS_NOT_FOUND',
    RESTAURANT_INACTIVE = 'RESTAURANT_INACTIVE',
    INVALID_SOCIAL_NETWORK_URL = 'INVALID_SOCIAL_NETWORK_URL',
    RESTAURANT_CLOSED_PERMANENTLY = 'RESTAURANT_CLOSED_PERMANENTLY',

    // RESTAURANT AI SETTINGS
    RESTAURANT_AI_SETTINGS_NOT_FOUND = 'RESTAURANT_AI_SETTINGS_NOT_FOUND',

    // RESTAURANT KEYWORDS
    RESTAURANT_KEYWORD_NOT_FOUND = 'RESTAURANT_KEYWORD_NOT_FOUND',
    RESTAURANT_KEYWORD_RANKING_REFRESH_NOT_ALLOWED = 'RESTAURANT_KEYWORD_RANKING_REFRESH_NOT_ALLOWED',

    // REVIEWS
    PUBLISH_REVIEW_ERROR = 'PUBLISH_REVIEW_ERROR',
    RETRIEVE_REVIEWS_ERROR = 'RETRIEVE_REVIEWS_ERROR',
    REVIEWS_UPDATE_ERROR = 'REVIEWS_UPDATE_ERROR',
    REVIEW_NOT_FOUND = 'REVIEW_NOT_FOUND',
    REVIEW_TOO_OLD = 'REVIEW_TOO_OLD',
    REVIEW_NOT_IN_RESULTS = 'REVIEW_NOT_IN_RESULTS',
    REVIEW_INCORRECT_SOCIAL_ID = 'REVIEW_INCORRECT_SOCIAL_ID',
    REVIEW_INCORRECT_SOCIAL_LINK = 'REVIEW_INCORRECT_SOCIAL_LINK',
    DOWNLOAD_REVIEWS_AS_PDF_FAILED = 'DOWNLOAD_REVIEWS_AS_PDF_FAILED',
    REVIEWS_PDF_EXPORT_LIMIT_EXCEEDED = 'REVIEWS_PDF_EXPORT_LIMIT_EXCEEDED',
    FAILED_SEMANTIC_ANALYSIS = 'FAILED_SEMANTIC_ANALYSIS',
    PRIVATE_REVIEW_NOT_FOUND = 'PRIVATE_REVIEW_NOT_FOUND',
    REVIEW_REPLY_BLOCKED = 'REVIEW_REPLY_BLOCKED',
    BOOKING_REVIEW_REPLY_UPDATE_NOT_SUPPORTED = 'BOOKING_REVIEW_REPLY_UPDATE_NOT_SUPPORTED',
    BOOKING_PROPERTY_ALREADY_CONNECTED = 'BOOKING_PROPERTY_ALREADY_CONNECTED',
    REVIEW_HAS_NO_CLIENT_ID = 'REVIEW_HAS_NO_CLIENT_ID',

    // ROUTING_ERROR
    ROUTING_ERROR = 'ROUTING_ERROR',

    // SEMANTIC ANALYSIS
    SEGMENT_ANALYSIS_PARENT_TOPIC_NOT_FOUND = 'SEGMENT_ANALYSIS_PARENT_TOPIC_NOT_FOUND',
    SEGMENT_ANALYSIS_PARENT_TOPIC_NOT_USER_INPUT = 'SEGMENT_ANALYSIS_PARENT_TOPIC_NOT_USER_INPUT',
    SEGMENT_ANALYSIS_TOPIC_PRUNING_ERROR = 'SEGMENT_ANALYSIS_TOPIC_PRUNING_ERROR',

    // SCRAPPER
    SCRAPPER_TOO_MANY_TRIES = 'SCRAPPER_TOO_MANY_TRIES',

    // STORE LOCATOR
    STORE_LOCATOR_ADDRESS_NOT_FOUND = 'STORE_LOCATOR_ADDRESS_NOT_FOUND',
    STORE_LOCATOR_DATA_FETCH_FAILED = 'STORE_LOCATOR_DATA_FETCH_FAILED',
    STORE_LOCATOR_DATA_BACKUP_USED = 'STORE_LOCATOR_DATA_BACKUP_USED',
    STORE_LOCATOR_GENERATION_ALREADY_RUNNING = 'STORE_LOCATOR_GENERATION_ALREADY_RUNNING',
    STORE_LOCATOR_INVALID_JOB_NAME = 'STORE_LOCATOR_INVALID_JOB_NAME',
    STORE_LOCATOR_COULD_NOT_UPDATE_STYLES = 'STORE_LOCATOR_COULD_NOT_UPDATE_STYLES',

    // STICKERS
    STICKER_NOT_FOUND = 'STICKER_NOT_FOUND',

    // TEMPLATES
    DEFAULT_TEMPLATES_GENERATION_FAILED = 'DEFAULT_TEMPLATES_GENERATION_FAILED',

    // TIKTOK
    TIKTOK_OAUTH_SCOPE_NOT_ACCEPTED = 'TIKTOK_OAUTH_SCOPE_NOT_ACCEPTED',

    // UBEREATS
    UBEREATS_STORE_NOT_FOUND = 'UBEREATS_STORE_NOT_FOUND',

    // USERS
    USER_HAS_NO_ORGANIZATION = 'USER_HAS_NO_ORGANIZATION',
    USER_UNKNOWN_ROLE = 'USER_UNKNOWN_ROLE',
    USER_CANNOT_UPDATE_USER_RESTAURANT = 'USER_CANNOT_UPDATE_USER_RESTAURANT',
    USER_CANNOT_CREATE_ADMIN = 'USER_CANNOT_CREATE_ADMIN',
    USER_NOT_FOUND = 'USER_NOT_FOUND',
    USER_NOT_VERIFIED = 'USER_NOT_VERIFIED',
    USER_WRONG_PASSWORD = 'USER_WRONG_PASSWORD',
    USER_CANNOT_DELETE_ADMIN = 'USER_CANNOT_DELETE_ADMIN',
    USER_HAVE_NO_ACCESS_TO_ACCOUNT = 'USER_HAVE_NO_ACCESS_TO_ACCOUNT',
    USER_CANNOT_SEE_RESTAURANTS = 'USER_CANNOT_SEE_RESTAURANTS',
    USER_CANNOT_DOWNGRADE_LAST_OWNER = 'USER_CANNOT_DOWNGRADE_LAST_OWNER',
    USER_HAS_LINKED_ENTITIES = 'USER_HAS_LINKED_ENTITIES',

    // WHEEL OF FORTUNE
    GIFT_NAME_TOO_LONG = 'GIFT_NAME_TOO_LONG',
    NO_AVAILABLE_GIFTS = 'NO_AVAILABLE_GIFTS',
    RESTAURANT_HAS_AN_ACTIVE_OR_PROGRAMMED_WHEEL_OF_FORTUNE = 'RESTAURANT_HAS_AN_ACTIVE_OR_PROGRAMMED_WHEEL_OF_FORTUNE',
    RESTAURANT_NOT_MANAGED_MISSING_IN_WHEEL_OF_FORTUNE = 'RESTAURANT_NOT_MANAGED_MISSING_IN_WHEEL_OF_FORTUNE',
    RESTAURANT_WHEEL_OF_FORTUNE_MULTIPLE_RESTAURANTS = 'RESTAURANT_WHEEL_OF_FORTUNE_MULTIPLE_RESTAURANTS',
    WHEEL_OF_FORTUNE_NOT_FOUND = 'WHEEL_OF_FORTUNE_NOT_FOUND',
    WHEEL_OF_FORTUNE_NOT_STARTED = 'WHEEL_OF_FORTUNE_NOT_STARTED',
    WRONG_RETRIEVAL_DATES = 'WRONG_RETRIEVAL_DATES',

    // LAMBDA
    LAMBDA_ERROR_GENERATING_PDF = 'LAMBDA_ERROR_GENERATING_PDF',
    LAMBDA_MAXIMUM_CALL_STACK_SIZE_EXCEEDED = 'LAMBDA_MAXIMUM_CALL_STACK_SIZE_EXCEEDED',
    LAMBDA_FUNCTION_NAME_NOT_FOUND = 'LAMBDA_FUNCTION_NAME_NOT_FOUND',

    // KEYWORD LAMBDA
    KEYWORD_LAMBDA_GENERATOR_ERROR = 'KEYWORD_LAMBDA_GENERATOR_ERROR',

    // YEXT
    YEXT_ACCOUNT_NOT_FOUND = 'YEXT_ACCOUNT_NOT_FOUND',
    YEXT_LOCATION_NOT_FOUND = 'YEXT_LOCATION_NOT_FOUND',
    YEXT_LOCATION_ALREADY_EXISTS = 'YEXT_LOCATION_ALREADY_EXISTS',
    YEXT_LOCATION_STATUS_IS_NOT_PROCESSED = 'YEXT_LOCATION_STATUS_IS_NOT_PROCESSED',
    YEXT_LOCATION_HAS_ACTIVE_SERVICES = 'YEXT_LOCATION_HAS_ACTIVE_SERVICES',
    YEXT_CANT_DELETE_BECAUSE_OF_ADD_REQUEST_STATUS = 'YEXT_CANT_DELETE_BECAUSE_OF_ADD_REQUEST_STATUS',
    YEXT_NOT_SUPPORTED = 'YEXT_NOT_SUPPORTED',
    CANNOT_MAP_RESTAURANT_TO_YEXT_ENTITY = 'CANNOT_MAP_RESTAURANT_TO_YEXT_ENTITY',
    CANNOT_ADD_LOCATION_FOR_BRAND_RESTAURANT = 'CANNOT_ADD_LOCATION_FOR_BRAND_RESTAURANT',
    UPDATE_YEXT_ADD_REQUEST_STATUS_MAX_RETRY = 'UPDATE_YEXT_ADD_REQUEST_STATUS_MAX_RETRY',
    YEXT_ADD_REQUEST_FAILED_OR_CANCELED = 'YEXT_ADD_REQUEST_FAILED_OR_CANCELED',
    YEXT_DELETE_LOCATION_FAILED = 'YEXT_DELETE_LOCATION_FAILED',
    UNHANDLED_YEXT_PUBLISHERS = 'UNHANDLED_YEXT_PUBLISHERS',

    // SQS
    SQS_MESSAGE_NOT_FOUND = 'SQS_MESSAGE_NOT_FOUND',
    SQS_INVALID_MESSAGE = 'SQS_INVALID_MESSAGE',

    // ROI
    MONTHLY_SAVE_ROI_INSIGHTS_ERROR = 'MONTHLY_SAVE_ROI_INSIGHTS_ERROR',

    // HUBSPOT
    HUBSPOT_CANNOT_SUBMIT_FORM = 'HUBSPOT_CANNOT_SUBMIT_FORM',

    // NOTIFICATIONS
    REVIEWS_FROM_DIFFERENT_RESTAURANTS = 'REVIEWS_FROM_DIFFERENT_RESTAURANTS',
    NOTIFICATION_NOT_FOUND = 'NOTIFICATION_NOT_FOUND',

    FAILED_TO_PROCESS_KEYWORD_SEARCH_IMPRESSIONS = 'FAILED_TO_PROCESS_KEYWORD_SEARCH_IMPRESSIONS',

    // DATES
    INVALID_DATE_RANGE = 'INVALID_DATE_RANGE',
    INVALID_COMPARISON_PERIOD = 'INVALID_COMPARISON_PERIOD',

    // SEVENROOMS
    SEVENROOMS_VENUE_ID_NOT_FOUND = 'SEVENROOMS_VENUE_ID_NOT_FOUND',
    SEVENROOMS_USER_NO_MARKETING_ACCESS = 'SEVENROOMS_USER_NO_MARKETING_ACCESS',
}
